import React from "react";
import styled from "styled-components";
import logo from "../assets/nxteye-logo.png";

const FooterSection = styled.section`
  width: 100%;
  background: linear-gradient(180deg, #06121e 0%, #323e49 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
  position: relative;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 60px 20px;
  }

  @media (max-width: 480px) {
    padding: 40px 16px;
  }
`;

const FooterContainer = styled.div`
  max-width: 1320px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const FooterTopRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center; /* NEW */
  gap: 48px; /* Reduced gap for better centering */
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 32px;
  }
`;

/* LEFT COLUMN – brand + nav */

const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 180px;
`;

const BrandRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const BrandText = styled.div`
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 24px;
  color: #ff8a2a;
`;

const Logo = styled.img`
  height: 32px;
`;

const FooterNavLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const FooterNavLink = styled.a`
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
  text-decoration: none;
  transition: opacity 0.3s ease;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

/* MIDDLE + RIGHT COLUMNS – addresses */

const OfficesWrapper = styled.div`
  display: flex;
  justify-content: center; /* ✅ center both blocks */
  align-items: center; /* ensure vertical alignment */
  gap: 64px;
  flex-wrap: wrap;
  width: 100%; /* ensure proper centering area */

  @media (max-width: 768px) {
    gap: 40px;
  }
`;

const AddressBlock = styled.div`
  max-width: 360px;
  color: #ffffff;
  text-align: center; /* NEW */
  display: flex;
  flex-direction: column;
  align-items: center; /* NEW */
  justify-content: center; /* NEW */
`;

const AddressTitle = styled.div`
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 8px;

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const AddressRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 6px;
`;

const IconWrapper = styled.span`
  display: inline-flex;
  margin-top: 2px;
  font-size: 16px;
`;

const AddressText = styled.div`
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  opacity: 0.9;

  @media (max-width: 480px) {
    font-size: 13px;
    line-height: 20px;
  }
`;

/* DIVIDER + BOTTOM ROW */

const FullWidthDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.2);
`;

const FooterBottomRow = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  padding-top: 10px;

  @media (max-width: 768px) {
    padding-top: 16px;
  }
`;

const FooterBottomInner = styled.div`
  width: 100%;
  max-width: 1320px;
  padding: 0 120px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 0 24px;
    text-align: center;
  }
`;

const FooterText = styled.div`
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 20px;
  color: #ffffff;

  @media (max-width: 480px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

const ContactRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  margin-top: 10px;
  color: white;
  font-family: "Montserrat", sans-serif;
  font-size: 15px;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }
`;

const EmailLink = styled.a`
  color: #ffffff;
  text-decoration: none;
  font-family: "Montserrat", sans-serif;
  position: relative;
  cursor: pointer;

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: -2px;
    width: 0;
    height: 2px;
    background: linear-gradient(
      106.71deg,
      #c69957 0%,
      #f7e096 47.6%,
      #a57632 93.27%
    );
    transform: translateX(-50%);
    transition: width 0.3s ease;
    border-radius: 2px;
  }

  &:hover::after {
    width: 100%;
  }
`;

const PhoneIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginTop: "3px" }}
  >
    <defs>
      <linearGradient
        id="goldGradientPhone"
        x1="0%"
        y1="0%"
        x2="100%"
        y2="100%"
      >
        <stop offset="0%" stopColor="#C69957" />
        <stop offset="50%" stopColor="#F7E096" />
        <stop offset="100%" stopColor="#A57632" />
      </linearGradient>
    </defs>
    <path
      fill="url(#goldGradientPhone)"
      d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1v3.5a1 1 0 01-1 1C10.41 21 3 13.59 3 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.46.57 3.58a1 1 0 01-.24 1.01l-2.2 2.2z"
    />
  </svg>
);

const MailIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginTop: "3px" }}
  >
    <defs>
      <linearGradient id="goldGradientMail" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#C69957" />
        <stop offset="50%" stopColor="#F7E096" />
        <stop offset="100%" stopColor="#A57632" />
      </linearGradient>
    </defs>
    <path
      fill="url(#goldGradientMail)"
      d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2zm8 7L4 6v12h16V6l-8 5z"
    />
  </svg>
);

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <FooterSection>
      <FooterContainer>
        {/* TOP ROW */}
        <FooterTopRow>
          {/* Middle + Right: Offices */}
          <OfficesWrapper>
            <AddressBlock>
              <AddressTitle>Head Office – U.A.E</AddressTitle>
              <AddressRow>
                <IconWrapper>
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="white"
                      style={{ marginTop: "3px" }}
                    >
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                    </svg>
                  </span>
                </IconWrapper>
                <AddressText>
                  Innovative Vision Analytics FZCO,
                  <br />
                  Office 523, Block C, Building 9W,
                  <br />
                  Dubai Airport Free Zone (DAFZA),
                  <br />
                  P.O. Box 293962, Dubai, U.A.E
                </AddressText>
              </AddressRow>
            </AddressBlock>

            <AddressBlock>
              <AddressTitle>Research &amp; Development – India</AddressTitle>
              <AddressRow>
                <IconWrapper>
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="white"
                      style={{ marginTop: "3px" }}
                    >
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                    </svg>
                  </span>
                </IconWrapper>
                <AddressText>
                  4th Floor, Nila Building,
                  <br />
                  Technopark Campus Phase 1,
                  <br />
                  Thiruvananthapuram, Kerala 695581
                </AddressText>
              </AddressRow>
            </AddressBlock>
          </OfficesWrapper>
        </FooterTopRow>

        <ContactRow>
          {/* Phone */}
          <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <PhoneIcon />
            <a
              href="tel:+971504805028"
              style={{
                color: "white",
                textDecoration: "none",
                fontFamily: "Montserrat, sans-serif",
              }}
            >
              +971 50480 5028
            </a>
          </span>

          {/* Email */}
          <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <MailIcon />
            <a
              href="mailto:ceo@iva.org.in"
              style={{
                color: "white",
                textDecoration: "none",
                fontFamily: "Montserrat, sans-serif",
                position: "relative",
              }}
              onMouseEnter={(e) => {
                e.target.style.textDecoration = "underline";
                e.target.style.textDecorationColor = "#F7E096"; // Gold underline
                e.target.style.textUnderlineOffset = "3px";
              }}
              onMouseLeave={(e) => {
                e.target.style.textDecoration = "none";
              }}
            >
              ceo@iva.org.in
            </a>
          </span>
        </ContactRow>

        <FullWidthDivider />

        {/* BOTTOM ROW */}
        <FooterBottomRow>
          <FooterBottomInner>
            <FooterText>Copyright © 2025 NxtEye</FooterText>
            <FooterText>Website by nxteye.com</FooterText>
          </FooterBottomInner>
        </FooterBottomRow>
      </FooterContainer>
    </FooterSection>
  );
};

export default Footer;
